export default __webpack_public_path__ + "static/media/vol4_3.aca42758.png";